module.exports = __webpack_public_path__ + "static/media/benefits_safety.3b4dff50.svg";